// extracted by mini-css-extract-plugin
export default {"drawerTableWrapper":"style_drawerTableWrapper__ixNwQ"};